import React, { useEffect, useState } from "react";
import AddIcon from "@mui/icons-material/Add";
import ConfirmModal from "../../components/ConfirmModal";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import CashierApi from "../../utility/CashierApi";

function AddCustomer() {
  const queryClient = useQueryClient();
  const { createData } = CashierApi();

  const [isModalOpen, setIsModalOpen] = useState(false);
  const [loading, setLoading] = useState(false);
  const [formData, setFormData] = useState({
    name: "",
    comment: "",
    preference: "",
  });

  const handleSubmit = (e) => {
    setLoading(true);
    e.preventDefault();
    mutation.mutate({ ...formData, title: "new customer" }, {});
  };

  const mutation = useMutation({
    mutationFn: (newCustomer) => createData("customers/store", newCustomer),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["customers"] });
      setIsModalOpen(false);
      setFormData({ name: "", comment: "", preference: "" });
      setLoading(false);
    },
  });

  const handleAddCustomer = () => {
    setIsModalOpen(true); // Open the confirmation modal
  };

  const handleCloseModal = () => {
    setIsModalOpen(false); // Close the modal
  };
  if (mutation.isLoading) return <div>Loading...</div>;
  if (mutation.isError) return <div>New Error</div>;
  return (
    <>
      <button
        onClick={handleAddCustomer}
        className="p-3 py-2.5 text-sm w-52 rounded-lg text-white flex justify-center items-center bg-gray-500"
      >
        Add Customer <AddIcon sx={{ fontSize: "20px" }} />
      </button>

      <ConfirmModal
        isOpen={isModalOpen}
        onClose={handleCloseModal}
        text1="Add new Customer"
        field={true}
        setFormData={setFormData}
        formData={formData}
        isLoading={loading}
        handleSubmit={handleSubmit}
        // text2="Details of the new Customer"
      />
    </>
  );
}

export default AddCustomer;
